import { DROP_BOX_CONFIG, DROP_BOX_API, SUPPORT_FILE_EXTENSIONS, setDriveTokenInfo, DROP_BOX } from './drives.constants';
import { baseUrlApis } from 'Api/index';
import axios from 'axios';
import { store } from 'Store/index';
import { convertUTCToLocale, getFileSize, handlerFileNameWithoutExtension, storageGetItem, storageRemoveItem, storageSetItem, windowActionFn } from 'Utils/utils';
import intl from 'react-intl-universal';

export default class DropboxApi {
  constructor() {
    this.downloadFileRequest = false;
    this.uploadFileRequest = false;
    this.alreadyShowError = false;
    this.CancelToken = axios.CancelToken;
    this.cancelDownloadFileFn = null;
    this.cancelUploadFileFn = null;
    this.numberOfAjaxCAllPending = 0;
    this.charsToEncode = /[\u007f-\uffff]/g;
    this.dropBoxAxios = null;

    this.init();
  }
  init() {
    this.dropBoxAxios = axios.create({
      baseURL: DROP_BOX_API.BASEURL,
    });
    this.dropBoxAxios.interceptors.request.use(
      (config) => {
        store.driveStore.numberOfAjaxCAllPendingIncrease();

        const accessToken = storageGetItem(localStorage, 'DropBoxAccessToken');

        if (accessToken) {
          config.headers = {
            Authorization: `Bearer ${accessToken}`,
            ...config.headers,
          };
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    this.dropBoxAxios.interceptors.response.use(
      (res) => {
        store.driveStore.numberOfAjaxCAllPendingDecrease();

        return res.data;
      },
      (error) => {
        store.driveStore.numberOfAjaxCAllPendingDecrease();

        if (error.message === 'Network Error') {
          let errorMsg = intl.formatMessage({ id: 'NetworkError' });

          store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
        }

        this.errorHandler(error);

        return Promise.reject(error);
      },
    );
  }
  http_header_safe_json(v) {
    return JSON.stringify(v).replace(this.charsToEncode, (c) => {
      return '\\u' + ('000' + c.charCodeAt(0).toString(16)).slice(-4);
    });
  }
  errorHandler(error) {
    let errorMsg;
    const { status } = error.response;

    if (status === 409) {
      errorMsg = intl.formatMessage({ id: 'InsufficientSpace' });
    } else if (status === 400) {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'InvalidToken' });
    } else if (status === 404) {
      errorMsg = intl.formatMessage({ id: 'FileNotExist' });
    } else {
      error.autoSignOut = true;
      errorMsg = intl.formatMessage({ id: 'Error.SignOutAndRetry' });
    }

    store.appStore.setGlobalMessage({ type: 'error', content: errorMsg });
  }
  signIn(success, closeWin) {
    let left = window.innerWidth / 2 - 300;
    let _hTime = null;
    let _hWin = windowActionFn(window, 'open', [DROP_BOX_CONFIG.AUTHORIZATION_URL(), 'DropBoxAuthorizationWin', `width=600, height=645, left=${left}, top=240`]);

    function onSignSuccess(token) {
      storageSetItem(localStorage, 'DropBoxAccessToken', token); //"null"
      success && success();
    }
    function onHandleWindowMessage(event) {
      
      let origin = baseUrlApis.getBaseUrl();

      if (event.data.dropBoxCode && `${event.origin}/` === origin) {
        onSignSuccess(event.data.dropBoxCode);
        clean();
      }
    }
    function onHandleStorage(e) {
      
      if (e.key === 'dropBoxCode') {
        onSignSuccess(e.newValue);
        clean();
      }
    }
    function clean() {
      if (!_hWin) {
        
        return;
      }
      _hWin.close();
      _hWin = null;
      closeWin && closeWin()
      _hTime && clearInterval(_hTime);
      _hTime = null;
      window.removeEventListener('message', onHandleWindowMessage);
      window.removeEventListener('storage', onHandleStorage);
    }
    // start to listen
    _hTime = setInterval(() => {
      if (_hWin.closed) {
        
        clean();
      }
    }, 2000);

    window.addEventListener('message', onHandleWindowMessage, false);
    window.addEventListener('storage', onHandleStorage, false);
  }
  signOut(success, fail) {
    try {
      this.dropBoxAxios({
        url: `${DROP_BOX_API.REVOKE_ACCESS_TOKEN}`,
        method: 'POST',
      })
        .then(() => {
          storageRemoveItem(localStorage, 'DropBoxAccessToken');
          success && success();
        })
        .catch((error) => {
          fail && fail(error);
        });
    } catch (error) {
      // fail && fail(error);
      this.errorHandler(error);
    }
  }
  getUserInfo(success, fail) {
    this.dropBoxAxios({
      url: DROP_BOX_API.GET_USER_INFO,
      method: 'POST',
    })
      .then((res) => {
        const accessToken = storageGetItem(localStorage, 'DropBoxAccessToken');

        res.id = res.account_id
        res.userAccount = res.email
        res.accessToken = accessToken
        setDriveTokenInfo(DROP_BOX, res.userAccount)
        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  getItems(folderId, success, fail) {
    this.dropBoxAxios({
      url: DROP_BOX_API.GET_FILES,
      method: 'POST',
      data: {
        path: folderId ? folderId : '',
        include_media_info: true,
      },
    })
      .then((res) => {
        let folders = [];
        let files = [];

        res.entries.forEach((item) => {

          if (item['.tag'] === 'folder') {
            item.size = '';
            item.modifiedTime = '';
            item.isFolder = true;
            folders.push(item);
          }
          if (item['.tag'] === 'file' && SUPPORT_FILE_EXTENSIONS.indexOf(item.name.replace(/.+\./,"")) > -1) {
            item.originSize = item.size
            item.size = getFileSize(item.size);
            item.modifiedTime = item.server_modified && convertUTCToLocale(item.server_modified);
            files.push(item);
          }
        });

        folders.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }

          return 0;
        });
        files.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }

          return 0;
        });

        const { saveType } = store.driveStore

        if (saveType) {
          files = files.filter((item) => {
            const fileName = item.name
            const fileType = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

            return fileType === saveType
          })
        }
        
        res.result = {
          files: [...folders, ...files],
        };

        success && success(res);
      })
      .catch((error) => {
        fail && fail(error);
      });
  }
  downloadFile(item, success, fail) {
    this.downloadFileRequest = true;
    this.dropBoxAxios({
      url: DROP_BOX_API.CONTENT_URL + DROP_BOX_API.DOWNLOAD_FILE,
      method: 'POST',
      headers: {
        'Dropbox-API-Arg': JSON.stringify({
          path: item.id,
        }),
      },
      responseType: 'blob',
      cancelToken: new this.CancelToken((c) => {
        // An executor function receives a cancel function as a parameter
        this.cancelDownloadFileFn = c;
      }),
    })
      .then((data) => {
        this.downloadFileRequest = false;
        success && success({ blob: data, id: item.id, fileName: item.name });
        // var file = new Blob([data], { type: data.type });

        // // 将二进制数据流转成URL对象
        // const url = window.URL.createObjectURL(file);
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', 'test.jpg'); // 需要指定文件格式。
        // document.body.appendChild(link);
        // link.click(); //点击事件
      })
      .catch((error) => {
        this.downloadFileRequest = false;

        fail && fail(error);
      });
  }
  cancelDownloadFile() {
    this.cancelDownloadFileFn && this.cancelDownloadFileFn();
  }
  createFolder({folderName, folderPath}) {
    let targetFolder = '/';

    folderPath &&
      folderPath.forEach((element, index) => {
        if (index !== 0) {
          targetFolder += `${element.name}/`;
        }
      });
    
    const data = JSON.stringify({
      autorename: true,
      path: `${targetFolder}${folderName}`
    })

    return this.dropBoxAxios({
      url: DROP_BOX_API.CREATE_FOLDER,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data
    })
  }
  createFile(file, folderPath, success, fail, progress) {
    // let fd = new FormData();
    // fd.append('data-binary', file);
    let targetFolder = '/';
    let fr = new FileReader();
    let fileName = handlerFileNameWithoutExtension(file.name);

    folderPath &&
      folderPath.forEach((element, index) => {
        if (index !== 0) {
          targetFolder += `${element.name}/`;
        }
      });

    fr.onload = (event) => {
      this.uploadFileRequest = true;
      this.dropBoxAxios({
        url: DROP_BOX_API.CONTENT_URL + DROP_BOX_API.CREATE_FILE,
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
          'Dropbox-API-Arg': this.http_header_safe_json({
            mode: 'overwrite',
            path: targetFolder + fileName,
            // autorename: false,
          }),
        },
        data: event.target.result,
        onUploadProgress: function(progressEvent) {
          if (progressEvent.lengthComputable) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

            progress && progress(percentCompleted);
          }
        },
        cancelToken: new this.CancelToken((c) => {
          // An executor function receives a cancel function as a parameter
          this.cancelUploadFileFn = c;
        }),
      })
        .then(() => {
          this.uploadFileRequest = false;
          success && success();
        })
        .catch((error) => {
          this.uploadFileRequest = false;

          fail && fail(error);
        });
    };

    fr.readAsArrayBuffer(file);
  }
  cancelUploadFile() {
    this.cancelUploadFileFn && this.cancelUploadFileFn();
  }
  updateFile(item, file, success, fail, progress) {
    let fr = new FileReader();

    fr.onload = (event) => {
      this.dropBoxAxios({
        url: DROP_BOX_API.CONTENT_URL + DROP_BOX_API.CREATE_FILE,
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
          'Dropbox-API-Arg': this.http_header_safe_json({
            path: item['path_display'],
            mode: {
              '.tag': 'update',
              update: item.rev,
            },
            autorename: true,
          }),
        },
        data: event.target.result,
        onUploadProgress: function(progressEvent) {
          if (progressEvent.lengthComputable) {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

            progress && progress(percentCompleted);
          }
        },
      })
        .then(() => {
          success && success();
        })
        .catch((error) => {
          fail && fail(error);
        });
    };

    fr.readAsArrayBuffer(file);
  }
  isSignIn() {
    let accessToken = storageGetItem(localStorage, 'DropBoxAccessToken');

    if (accessToken) {
      return true;
    } else {
      return false;
    }
  }
}
